import React, { useEffect, useRef, useState } from "react";
import { useTranslate } from "../components/TranslationText";
import Loader from "../components/Loader";
import { useDispatch, useSelector } from "react-redux";
import NetaqInput from "../components/NetaqInput";
import Select from "react-select";
import ActionButton from "../components/ActionButton";
import { useLocation, useNavigate } from "react-router";
import { ToastContainer, toast } from "react-toastify";
import {
  FetchCreateOrEditUpdateArabianHorseDataServiceRequestthunk,
  FetchGetServiceDefinitionByIdthunk,
  FetchGetServicesRequestByIdthunk,
} from "../Redux/ServicesRequests/ServicesRequestsAction";
import {
  resetGetServicesRequestByIdData,
  resetToasterMessageServicesRequests,
} from "../Redux/ServicesRequests/ServicesRequestsSlice";
import { FetchSubOwnerProfilesByIdthunk } from "../Redux/ShowEntry/ShowEntryAction";
import SimpleFileUpload from "../components/SimpleFileUpload";
import { base64ToBlob } from "../helper/base64ToBlob";
import dayjs from "dayjs";
import { FetchOwnerHorsesDropDownthunk } from "../Redux/OwnerProfile/OwnerProfileAction";
import { FetchHorseColorsthunk } from "../Redux/LookUp/LookUpAction";
import EahsForm from "../components/EahsForm";
import { eFormButtonsContainer, eformCheckBox, eformInput, eformTerms, serviceRequestHeadContainer, serviceRequestTitle, userDropDown } from "../common/cssclasses";
import DraftBtn from "../components/servicesButtons/DraftBtn";
import ApproveAndPayLaterBtn from "../components/servicesButtons/ApproveAndPayLaterBtn";
import SubmitAndPay from "../components/servicesButtons/SubmitAndPay";
import SubmitServiceBtn from "../components/servicesButtons/SubmitServiceBtn";

export default function RequestToUpdateArabianHorseData() {
  //env 
  const UMBRACOURL = process.env.REACT_APP_UMBRACO;
  //const UMBRACOURL = process.env.REACT_APP_Local_UMBRACO;
  const BaseURL = process.env.REACT_APP_BASE_URL;

  //selector
  const { currentLanguage } = useSelector((state) => state.studBookSlice);

  const {
    toasterMessageServicesRequests,
    servicesRequestsLoading,
    getServicesRequestByIdData,
    getServiceDefinitionByIdData,
    createOrEditUpdateArabianHorseDataServiceRequestData,
  } = useSelector((state) => state.servicesRequestsSlice);

  const { horseColorsData } = useSelector(
    (state) => state.lookUpSlice
  );

  const { ownerHorsesDropDownData } = useSelector(
    (state) => state.ownerProfileSlice
  );

  const userProfile = JSON.parse(localStorage.getItem("eahsUserProfile"));
  const subOwnerProfilesByIdData = userProfile?.subAccounts ?? [];

  const dispatch = useDispatch();

  const { translate } = useTranslate();

  const navigate = useNavigate();

  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);

  const serviceId = searchParams.has("serviceId")
    ? searchParams.get("serviceId")
    : null;

  const id = searchParams.has("id") ? searchParams.get("id") : null;

  const action = searchParams.has("action") ? searchParams.get("action") : null;
  const ownerId = searchParams.has("ownerId") ? searchParams.get("ownerId") : null;

  //state
  const [formModel, setFormModel] = useState({
    id: "",
    updateArabianHorseDataId: "",
    eventName: "",
    comment: "",
    referenceNumber: "",
    requestsType: "",
    paymentStatus: "",

    horse: "",
    horseDrop: {
      label: translate("web.horse", "Horse"),
      value: null,
    },

    horseName: "",
    birthDate: "",
    birthDateMin: "",

    fromColor: "",
    toColor: "",
    toColorDrop: {
      label: translate("web.color", "Color"),
      value: null,
    },

    fromSex: "",
    toSex: "Gelding",
    changeSex: false,
    changeColor: false,

    castredDate: null,

    ownerComment: "",

    filePathVeterinarianReport: "",
    fileTypeVeterinarianReport: "",
    fileNameVeterinarianReport: "",
    fileUrlVeterinarianReport: "",
    veterinarianReportAttachmentFile: null,

    isRegistration: true,
    address: "",
    mobile: "",
  });

  const [errorHorse, setErrorHorse] = useState(false);
  const [errorToColor, setErrorToColor] = useState(false);
  const [errorCastredDate, setErrorCastredDate] = useState(false);
  const [errorVeterinarianReport, setErrorVeterinarianReport] = useState(false);
  const [errorAddress, setErrorAddress] = useState(false);
  const [errorMobile, setErrorMobile] = useState(false);

  const [isPhoneNumberValid, setIsPhoneNumberValid] = useState(true);

  //use ref
  const horseRef = useRef(null);
  const toColorRef = useRef(null);
  const castredDateRef = useRef(null);
  const veterinarianReportRef = useRef(null);
  const addressRef = useRef(null);
  const mobileRef = useRef(null);

  const [
    veterinarianReportAttachmentFile,
    setVeterinarianReportAttachmentFile,
  ] = useState([]);

  const _isOnlinePayment = useRef("");
  const _status = useRef("");

  const [checkedItems, setCheckedItems] = useState({});
  // const [checkedItems, setCheckedItems] = useState({
  //   option1: false,
  //   option2: false,
  // });

  const [profile, setProfile] = useState({
    label:
      !!userProfile &&
      userProfile?.ownerRegisterNo +
      " - " +
      userProfile[`fullName${currentLanguage === "en" ? "" : "Ar"}`],
    value: localStorage.getItem("EAHSUserID"),
  });
  const subAccountId = localStorage.getItem("currentSubAccountId");

  const customStyles = {
    control: (base) => ({
      ...base,
      height: 50,
      minHeight: 50,
    }),
  };

  //function

  const handleFormChange = (e, input) => {

    if (input === "horse") {
      let horse = ownerHorsesDropDownData.filter((item) => item.id == e.value);

      if (horse.length > 0) {
        setFormModel({
          ...formModel,
          horse: e.value,
          horseDrop: e,
          horseName: (horse[0]?.registerNumber != null ? (horse[0]?.registerNumber + " - ") : "") + horse[0]?.name ?? "",
          birthDate: dayjs(horse[0]?.birthDate ?? "").format('DD/MM/YYYY'),
          birthDateMin: horse[0]?.birthDate ?? "",
          fromColor: horse[0]?.color ?? "",
          fromSex: horse[0]?.gender ?? "",
          changeSex: false,
          castredDate: null,
          veterinarianReportAttachmentFile: null
        });
      }

      else {
        setFormModel({
          ...formModel,
          horse: "",
          horseDrop: {
            label: translate("web.horse", "Horse"),
            value: null,
          },
          horseName: "",
          birthDate: "",
          birthDateMin: "",
          fromColor: "",
          fromSex: "",
          changeSex: false,
          castredDate: null
        });
      }

      setVeterinarianReportAttachmentFile([]);
    }
    else if (!!input && input === "toColor") {
      setFormModel({
        ...formModel,
        toColor: e.value,
        toColorDrop: e,
      });
    }
    else if (input === "changeSex") {
      setFormModel({
        ...formModel,
        changeSex: e.target.checked,
        castredDate: null,
        veterinarianReportAttachmentFile: null
      });

      setVeterinarianReportAttachmentFile([]);
    }
    else if (input === "changeColor") {
      setFormModel({
        ...formModel,
        changeColor: e.target.checked,
        toColor: "",
        toColorDrop: {
          label: translate("web.color", "Color"),
          value: null,
        },
      });
    }
    else if (input === "receiveType") {
      setFormModel({
        ...formModel,
        isRegistration: e.target.value === "Registration",
        address: "",
        mobile: ""
      });
    }
    else {
      setFormModel({
        ...formModel,
        [e.target.name]: e.target.value,
      });
    }
  };

  const handleUploadVeterinarianReportChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      if (e.target.files[0].size > 10 * 1024 * 1024) {
        toast.error(translate("web.fileSizeLimit", "File size 10MB limit."));
      } else {
        setFormModel({
          ...formModel,
          veterinarianReportAttachmentFile: e.target.files[0],
        });

        setVeterinarianReportAttachmentFile([
          {
            file: e.target.files[0],
            name: e.target.files[0].name,
          },
        ]);
      }
    }
  };

  const validInputs = () => {
    let valid = true;

    if (
      formModel.horse === ""
    ) {
      setErrorHorse(true);
      valid = false;

      horseRef?.current?.focus();
      return;
    }
    else {
      setErrorHorse(false);
    }

    if (
      formModel.changeColor && (formModel.toColor === "" || formModel.toColor == null)
    ) {
      setErrorToColor(true);
      valid = false;

      toColorRef?.current?.focus();
      return;
    }
    else {
      setErrorToColor(false);
    }

    if (
      formModel.changeSex && formModel.castredDate == null
    ) {
      setErrorCastredDate(true);
      valid = false;

      castredDateRef?.current?.focus();
      return;
    }
    else {
      setErrorCastredDate(false);
    }

    if (
      formModel.changeSex
      && veterinarianReportAttachmentFile.length === 0
      && formModel.fileUrlVeterinarianReport === ""
    ) {
      setErrorVeterinarianReport(true);
      valid = false;

      veterinarianReportRef?.current?.focus();
      return;
    }
    else {
      setErrorVeterinarianReport(false);
    }

    if (
      !formModel.changeColor && !formModel.changeSex
    ) {
      valid = false;

      toast.error(
        translate("web.errorMustChangeColorOrSex", "Must change color or sex of horse")
      );
      return;
    }

    if (
      !formModel.isRegistration && (formModel.address === "" || formModel.address == null || formModel.address.length < 50)
    ) {
      setErrorAddress(true);
      valid = false;
      addressRef?.current?.focus();

      toast.error(
        translate("web.errorAddressLength50Chars", "Can not address length less than 50 characters")
      );

      return;
    }
    else {
      setErrorAddress(false);
    }

    if (
      !formModel.isRegistration && (formModel.mobile === "" || formModel.mobile == null)
    ) {
      setErrorMobile(true);
      valid = false;
      mobileRef?.current?.focus();
      return;
    }
    else {
      setErrorMobile(false);
    }

    //term
    if (Object.values(checkedItems).length > 0) {  // Optional safe check
      const allTermsChecked = Object.values(checkedItems).every((isChecked) => isChecked);

      if (!allTermsChecked && action == null) {
        toast.error(
          translate("web.pleaseCheckAllTerms", "Please Check All Terms")
        );
        valid = false;
      }
    }

    // if (
    //   !checkedItems.option1
    //   || !checkedItems.option2
    // ) {
    //   toast.error(
    //     translate("web.pleaseCheckTerm", "Please Check Term")
    //   );
    //   valid = false;
    // }

    return valid;
  }

  const handelFormSubmit = (status, isOnlinePayment, buttonAction = 'Draft') => {
    if (getServiceDefinitionByIdData.serviceFees > 0 && formModel.paymentStatus === "Pendding" && formModel.requestsType === "BackOffice" && formModel.eventName !== "SentBack") {
      const returnUrl = `${BaseURL}/profile?activeTab=${"e_services"}&serviceId=${id}`;

      const encodeURI = encodeURIComponent(returnUrl);

      window.location.href = `${UMBRACOURL}/BackofficePayment/PaymentGetway?entityId=${id}&paymentType=15&userId=${localStorage.getItem("EAHSUserID")}&returnUrl=${encodeURI}&isOnline=${isOnlinePayment}&lang=${currentLanguage}`;
    }
    else {
      if (
        validInputs()
      ) {
        _isOnlinePayment.current = isOnlinePayment;
        _status.current = status;

        let params = {
          id: id == null ? '' : id,
          updateArabianHorseDataId: formModel.updateArabianHorseDataId,
          ownerId: getUserID(),
          horse: formModel.horse,
          changeColor: formModel.changeColor,
          fromColor: formModel.fromColor,
          toColor: formModel.toColor,
          changeSex: formModel.changeSex,
          fromSex: formModel.fromSex,
          toSex: formModel.toSex,
          castredDate: formModel.castredDate != null ? dayjs(formModel.castredDate).format("DD/MM/YYYY") : '',
          veterinarianReportAttachmentFile: formModel.veterinarianReportAttachmentFile,
          status: status,
          ownerComment: formModel.ownerComment,
          receiveType: formModel.isRegistration ? 1 : 2,
          address: formModel.address,
          mobile: formModel.mobile,
          buttonAction: buttonAction
        };

        dispatch(FetchCreateOrEditUpdateArabianHorseDataServiceRequestthunk(params));
      }
      else {
        toast.error(
          translate("web.completeTheRequiredData", "Complete The Required Data")
        );
      }
    }
  };

  const handelSelectedAccountChange = async (element) => {
    let params = {
      ownerId: element.value,
      skip: 0,
      take: 1000,
      langauge: currentLanguage,
      horseTypeFilter: "1",
      searchValue: "",
      sortBy: "-1",
    };
    dispatch(FetchOwnerHorsesDropDownthunk(params));

    setProfile(element);

    setFormModel({
      ...formModel,

      horse: "",
      horseDrop: {
        label: translate("web.horse", "Horse"),
        value: null,
      },

      horseName: "",
      birthDate: "",
      birthDateMin: "",
      fromColor: "",
      toColor: "",
      toColorDrop: {
        label: translate("web.color", "Color"),
        value: null,
      },

      fromSex: "",
      toSex: "GELDING",
      castredDate: null,
      veterinarianReportAttachmentFile: null,
    });

    setVeterinarianReportAttachmentFile([]);
  };

  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;

    setCheckedItems((prev) => ({
      ...prev,
      [name]: checked,
    }));
  };

  function CheckIfAgentHasPermission() {
    const AgentHasPermission = userProfile.subAccounts
      .filter((x) => x.value == subAccountId)[0]
      .ownersPermissionsList.some(
        (x) =>
          x.permissionName === "UpdateArabianHorseData" || x.permissionName === "All"
      );
    return AgentHasPermission;
  }

  // const getUserID = () => {
  //   const userID =
  //     !!userProfile && userProfile?.accountType !== "Agent" ? profile.value : subAccountId;
  //   return userID;
  // };
  const getUserID = () => {
    let userID =
      !!userProfile && userProfile?.accountType !== "Agent" ? profile.value : subAccountId;
    if ((action == null || action === "edit") == false) {
      userID = subAccountId;
    }
    return userID;
  };
  const getSelectedAccountName = () => {
    const selectAccount = userProfile.subAccounts.filter(
      (x) => x.value == subAccountId
    );

    if (selectAccount.length > 0) {
      return selectAccount[0];
    }
    else {
      return false;
    }
  };

  const dismissAll = () => toast.dismiss();

  const handelDisabledButton = () => {
    if (
      action === "view"
      || (action === "approve" && formModel.eventName !== "SentBack")
    ) {
      return true;
    }
    else {
      return false;
    }
  };

  const setPhoneNumber = (value) => {
    setFormModel((prev) => ({
      ...prev,
      mobile: value
    }));
  }

  //Effect
  useEffect(() => {
    if (id != null) {
      let params = {
        language: currentLanguage,
        id: id,
        ownerId: ownerId,
      };

      dispatch(FetchGetServicesRequestByIdthunk(params));
    }

    return () => {
      dispatch(resetGetServicesRequestByIdData());
    };
  }, []);

  useEffect(() => {
    if (!!userProfile && userProfile?.haveProfileSignture != true) {
      toast.error(
        translate(
          "web.completeOwnerProfileData",
          "Please complete the personal data of the profile."
        )
      );

      setTimeout(() => {
        navigate("/profile");
      }, 3000);
    }

    if (!!userProfile && userProfile?.accountType === "Agent") {
      if (userProfile.id == subAccountId) {
        navigate("/403-Not-Authrized");
      }

      if (!CheckIfAgentHasPermission()) {
        navigate("/403-Not-Authrized");
      }
    }

    dispatch(FetchHorseColorsthunk({ langauge: currentLanguage }));

    let params = {
      ownerId: getUserID(),
      skip: 0,
      take: 1000,
      langauge: currentLanguage,
      horseTypeFilter: "1",
      searchValue: "",
      sortBy: "-1",
    };
    dispatch(FetchOwnerHorsesDropDownthunk(params));

    let subOwnerProfilesParams = {
      id: getUserID(),
      langauge: currentLanguage,
    };
    dispatch(FetchSubOwnerProfilesByIdthunk(subOwnerProfilesParams));

    dispatch(FetchGetServiceDefinitionByIdthunk(serviceId));
  }, [currentLanguage]);

  useEffect(() => {

    if (getServicesRequestByIdData != null &&
      Object.keys(getServicesRequestByIdData).length > 0 && (getServicesRequestByIdData.serviceDefinitionId == serviceId)
    ) {
      setFormModel({
        ...formModel,
        eventName: getServicesRequestByIdData.eventName,
        comment: getServicesRequestByIdData.comment,
        requestsType: getServicesRequestByIdData.requestsType,
        paymentStatus: getServicesRequestByIdData.paymentStatus,
        referenceNumber: " - " + getServicesRequestByIdData.referenceNumber,

        updateArabianHorseDataId: getServicesRequestByIdData.updateArabianHorseDataDto.updateArabianHorseDataId,

        horse: getServicesRequestByIdData.updateArabianHorseDataDto.horse,
        horseDrop: {
          label: getServicesRequestByIdData.updateArabianHorseDataDto.horseName,
          value: getServicesRequestByIdData.updateArabianHorseDataDto.horse,
        },

        horseName: getServicesRequestByIdData.updateArabianHorseDataDto.horseName,

        birthDate: getServicesRequestByIdData.updateArabianHorseDataDto.birthDate,
        birthDateMin: getServicesRequestByIdData.updateArabianHorseDataDto.birthDateMin,
        changeColor: getServicesRequestByIdData.updateArabianHorseDataDto.changeColor,
        fromColor: getServicesRequestByIdData.updateArabianHorseDataDto.fromColor,
        toColor: getServicesRequestByIdData.updateArabianHorseDataDto.toColor ?? "",
        toColorDrop: {
          label: getServicesRequestByIdData.updateArabianHorseDataDto.toColorName ?? translate("web.color", "Color"),
          value: getServicesRequestByIdData.updateArabianHorseDataDto.toColor,
        },
        changeSex: getServicesRequestByIdData.updateArabianHorseDataDto.changeSex,
        fromSex: getServicesRequestByIdData.updateArabianHorseDataDto.fromSex,
        //toSex: getServicesRequestByIdData.updateArabianHorseDataDto.toSex,
        castredDate: getServicesRequestByIdData.updateArabianHorseDataDto.castredDateTime != null ? dayjs(getServicesRequestByIdData.updateArabianHorseDataDto.castredDateTime).format("YYYY-MM-DD") : null,
        ownerComment: getServicesRequestByIdData.updateArabianHorseDataDto.ownerComment != null ? getServicesRequestByIdData.updateArabianHorseDataDto.ownerComment : "",
        filePathVeterinarianReport: getServicesRequestByIdData.updateArabianHorseDataDto.veterinarianReportAttachmentFileModel.filePath,
        fileTypeVeterinarianReport: getServicesRequestByIdData.updateArabianHorseDataDto.veterinarianReportAttachmentFileModel.fileType,
        fileNameVeterinarianReport: getServicesRequestByIdData.updateArabianHorseDataDto.veterinarianReportAttachmentFileModel.fileName,
        fileUrlVeterinarianReport: getServicesRequestByIdData.updateArabianHorseDataDto.veterinarianReportAttachmentFileModel.fileUrl,

        isRegistration: getServicesRequestByIdData.updateArabianHorseDataDto.isRegistration,
        address: getServicesRequestByIdData.updateArabianHorseDataDto.address,
        mobile: getServicesRequestByIdData.updateArabianHorseDataDto.mobile,
      });

      //another owner
      if (
        getServicesRequestByIdData.updateArabianHorseDataDto.ownerId !==
        getServicesRequestByIdData.updateArabianHorseDataDto.createdBy &&
        subOwnerProfilesByIdData.length > 0 &&
        getServicesRequestByIdData.requestsType !== "BackOffice"
      ) {
        let params = {
          ownerId: getServicesRequestByIdData.updateArabianHorseDataDto.ownerId,
          skip: 0,
          take: 1000,
          langauge: currentLanguage,
          horseTypeFilter: "1",
          searchValue: "",
          sortBy: "-1",
        };
        dispatch(FetchOwnerHorsesDropDownthunk(params));

        //update profile
        setProfile({
          label:
            subOwnerProfilesByIdData.filter(
              (item) =>
                item.value ==
                getServicesRequestByIdData.updateArabianHorseDataDto.ownerId
            )[0].registerNo +
            " - " +
            subOwnerProfilesByIdData.filter(
              (item) =>
                item.value ==
                getServicesRequestByIdData.updateArabianHorseDataDto.ownerId
            )[0][`text${currentLanguage === "en" ? "" : "Ar"}`],
          value: subOwnerProfilesByIdData.filter(
            (item) =>
              item.value == getServicesRequestByIdData.updateArabianHorseDataDto.ownerId
          )[0].value,
        });
      }

      //options
      // setCheckedItems({
      //   option1: true,
      //   option2: true,
      // });
    }
  }, [
    getServicesRequestByIdData,
  ]);

  useEffect(() => {
    if (
      toasterMessageServicesRequests != null &&
      toasterMessageServicesRequests === "save"
    ) {
      if (_isOnlinePayment.current !== "") {
        toast.success(
          translate(
            "web.yourRequestHasSubmittedSuccessfully",
            "Your Request Has Submitted Successfully"
          )
        );
      } else {
        toast.success(
          translate("web.dataSavedSuccessfully", "Data Saved Successfully")
        );
      }

      dispatch(resetToasterMessageServicesRequests());

      setTimeout(() => {
        if (_isOnlinePayment.current !== "") {
          const returnUrl = `${BaseURL}/profile?activeTab=${"e_services"}&serviceId=${createOrEditUpdateArabianHorseDataServiceRequestData.id}`;

          const encodeURI = encodeURIComponent(returnUrl);

          window.location.href = `${UMBRACOURL}/BackofficePayment/PaymentGetway?entityId=${createOrEditUpdateArabianHorseDataServiceRequestData.id}&paymentType=15&userId=${localStorage.getItem(
            "EAHSUserID"
          )}&returnUrl=${encodeURI}&isOnline=${_isOnlinePayment.current}&lang=${currentLanguage}`;
        } else {
          if (_status.current === "Submit" && formModel.eventName !== "SentBack") {
            navigate(`/profile?activeTab=${"e_services"}&serviceId=${createOrEditUpdateArabianHorseDataServiceRequestData.id}`);
          }
          else {
            navigate(`/profile?activeTab=${"e_services"}`);
          }
        }
      }, 1000);
    }

    //error
    else if (toasterMessageServicesRequests != null && toasterMessageServicesRequests !== "save") {
      if (toasterMessageServicesRequests !== "errorServiceDetails") {

        toast.error(
          translate(toasterMessageServicesRequests, toasterMessageServicesRequests)
        );

        dispatch(resetToasterMessageServicesRequests());
      }

      else if (toasterMessageServicesRequests === "errorServiceDetails") {
        toast.error(
          translate("web.createServiceRequestFailed", "Service Request Failed")
        );

        dispatch(resetToasterMessageServicesRequests());

        setTimeout(() => {
          navigate(`/profile?activeTab=${"e_services"}`);
        }, 1000);
      }
    }
  }, [toasterMessageServicesRequests]);

  useEffect(() => {
    if (getServiceDefinitionByIdData?.termsList) {
      const initialState = {};
      getServiceDefinitionByIdData.termsList.forEach((_, index) => {
        initialState[`option${index + 1}`] = false;
      });
      setCheckedItems(initialState);
    }
  }, [getServiceDefinitionByIdData?.termsList]);

  //consoles
  console.log(formModel)

  return (
    <>
      {/* loading div */}
      <div
        className={`page-overlay text-center ${servicesRequestsLoading
          ? "classdisplay"
          : "classnotdisplay"
          }`}
      >
        <div className="loaderDiv">
          <Loader />
        </div>
      </div>

      {/* toast */}
      <ToastContainer
        position="top-right"
        onClick={dismissAll}
        theme="colored"
        autoClose={5000}
      />

      {/* content page */}
      <div className={serviceRequestHeadContainer}>
        {/* update Arabian Horse Data */}
        <h2 className={serviceRequestTitle}>
          {currentLanguage === "en"
            ? getServiceDefinitionByIdData.nameEn
            : getServiceDefinitionByIdData.nameAr} {formModel.referenceNumber}{" "}
        </h2>

        {/* Selected Account */}
        {subOwnerProfilesByIdData.length > 0 &&
          (action == null || action === "edit") &&
          (
            <div className={userDropDown}>
              {!!userProfile && userProfile?.accountType !== "Agent" ? (
                <>
                  <NetaqInput
                    label={translate("web.selectedAccount", "Selected Account")}
                    name="selectAccount"
                    type="select"
                    listSelect={[
                      ...(!!subOwnerProfilesByIdData &&
                        !!subOwnerProfilesByIdData.length > 0 &&
                        subOwnerProfilesByIdData.map((a) => ({
                          label:
                            a?.registerNo +
                            " - " +
                            a[`text${currentLanguage === "en" ? "" : "Ar"}`],
                          value: a.value,
                        }))),
                    ]}
                    value={profile}
                    onChange={(e) => {
                      handelSelectedAccountChange(e);
                    }}
                    placeholder={localStorage.getItem("EAHSUserFullName")}
                  />
                </>
              ) : (
                <label className="capatalize_text">
                  {getSelectedAccountName()?.registerNo +
                    " - " +
                    getSelectedAccountName()[
                    `text${currentLanguage === "en" ? "" : "Ar"}`
                    ]}
                </label>
              )}
            </div>
          )}
      </div>
      <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate("web.horseDetails", "Horse Details")}>
        <div className={eformInput}>
          <label>
            {translate("web.horse", "Horse")}
            <i className=" colorred"> *</i>
          </label>
          <Select
            options={[
              {
                label: translate("web.horse", "Horse"),
                value: null,
              },
              ...(!!ownerHorsesDropDownData &&
                ownerHorsesDropDownData.map((a) => ({
                  label: a.registerNumber + " - " + a.name,
                  value: a.id,
                }))),
            ]}
            value={formModel.horseDrop}
            onChange={(e) => handleFormChange(e, "horse")}
            placeholder={translate("web.horse", "Horse")}
            name={"horse"}
            isSearchable
            noOptionsMessage={() =>
              translate("web.noOptions", "No Options")
            }
            autoFocus={true}
            key={"horse"}
            isDisabled={handelDisabledButton()}
            ref={horseRef}
          />
          {errorHorse && (
            <span style={{ color: "red" }}>
              {translate("web.requiredField", "Required Field")}
            </span>
          )}
        </div>

        <div className={eformInput}>
          <NetaqInput
            label={translate("web.birthDate", "Birth Date")}
            name={"birthDate"}
            type={"text"}
            value={
              formModel.birthDate
            }
            disabled={true}
          />
        </div>

        <div className={eformInput}>
          <NetaqInput
            label={translate("web.color", "Color")}
            name={"fromColor"}
            type={"text"}
            value={
              formModel.fromColor
            }
            disabled={true}
          />
        </div>

        <div className={eformInput}>
          <NetaqInput
            label={translate("web.sex", "Sex")}
            name={"fromSex"}
            type={"text"}
            value={translate(
              `web._${formModel.fromSex.toLowerCase()}`,
              formModel.fromSex
            )}
            disabled={true}
          />
        </div>

        <div className={eformInput}>
          <div style={{ marginBottom: 5 }}>
            <NetaqInput
              type={"checkbox"}
              label={translate(
                "web.changeColor",
                "Change Color"
              ) + " " + translate('web.to', 'To')}
              name="changeColor"
              checked={formModel.changeColor}
              onChange={(e) => handleFormChange(e, "changeColor")}
              disabled={handelDisabledButton()}
            />
          </div>
          <Select
            options={[
              {
                label: translate("web.toColor", "To Color"),
                value: null,
              },
              ...(!!horseColorsData &&
                horseColorsData.map((a) => ({
                  label: a.nameEn,
                  value: a.id,
                }))),
            ]}
            value={formModel.toColorDrop}
            onChange={(e) => handleFormChange(e, "toColor")}
            placeholder={translate("web.toColor", "To Color")}
            name={"toColor"}
            isSearchable
            noOptionsMessage={() =>
              translate("web.noOptions", "No Options")
            }
            key={"toColor"}
            isDisabled={handelDisabledButton() || !formModel.changeColor}
            ref={toColorRef}
          />
          {errorToColor && (
            <span style={{ color: "red" }}>
              {translate("web.requiredField", "Required Field")}
            </span>
          )}
        </div>



        {formModel.fromSex === "Stallion" && (
          <>
            <div className={eformInput}>
              <div style={{ marginBottom: 5 }}>
                <NetaqInput
                  type={"checkbox"}
                  label={translate(
                    "web.changeSex",
                    "Change Sex"
                  ) + " " + translate('web.to', 'To')}
                  name="changeSex"
                  checked={formModel.changeSex}
                  onChange={(e) => handleFormChange(e, "changeSex")}
                  disabled={handelDisabledButton()}
                />
              </div>
              <NetaqInput
                hideLable
                label={translate("web.toSex", "To Sex")}
                name={"toSex"}
                type={"text"}
                value={
                  translate("web.gelding", "GELDING")
                }
                disabled={true}
              />
            </div>


            {formModel.changeSex && (
              <div className={eformInput}>
                <NetaqInput
                  htmlTags={
                    formModel.castredDate ?
                      <p className="me-auto px-3 effectiveDateParagraph" style={{ textAlign: 'left' }}>
                        {
                          dayjs(formModel.castredDate).format("DD/MM/YYYY")
                        }
                      </p> :
                      <p className="me-auto px-3 effectiveDateParagraph" style={{ textAlign: 'left' }}>
                        DD/MM/YYYY
                      </p>
                  }
                  name={"castredDate"}
                  type={"normalDateService"}
                  label={translate("web.castredDate", "Castred Date")}
                  onChange={(e) => handleFormChange(e, "castredDate")}
                  value={formModel.castredDate}
                  required={true}
                  minDate={dayjs(formModel.birthDateMin).format("YYYY-MM-DD")}
                  maxDate={dayjs().format("YYYY-MM-DD")}
                  disabled={handelDisabledButton()}
                  ref={castredDateRef}
                />
                {errorCastredDate && (
                  <span style={{ color: "red" }}>
                    {translate("web.requiredField", "Required Field")}
                  </span>
                )}
              </div>
            )}
          </>
        )}
      </EahsForm>

      {formModel.changeSex && (
        <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate("web.uploadDocument", "Upload Document")}>
          <label>
            {translate("web.veterinaryCertificate", "Veterinary Certificate")}
            <i className=" colorred"> *</i>
          </label>
          <div className={eformInput}>
            <SimpleFileUpload
              contentInputUpload={translate("web.uploadCertificatePdfPng", "Upload Certificate (pdf,png)")}
              isMulti={false}
              initialFiles={
                !!formModel.filePathVeterinarianReport &&
                  !!formModel.fileUrlVeterinarianReport &&
                  veterinarianReportAttachmentFile.length === 0
                  ? [
                    {
                      file: formModel?.fileUrlVeterinarianReport,
                      name: formModel?.fileNameVeterinarianReport,
                    },
                  ]
                  : veterinarianReportAttachmentFile
              }
              isServer={
                !!formModel.filePathVeterinarianReport &&
                  !!formModel.fileUrlVeterinarianReport &&
                  veterinarianReportAttachmentFile.length === 0
                  ? true
                  : false
              }
              onChange={handleUploadVeterinarianReportChange}
              accept={"image/*,application/pdf"}
              disabled={
                ((action === "approve" && formModel.eventName !== "SentBack") || action === "view") ?
                  true
                  : false
              }
              ref={veterinarianReportRef}
            />
            {
              errorVeterinarianReport && (
                <span style={{ color: "red", display: errorVeterinarianReport }}>
                  {translate("web.requiredField", "Required Field")}
                </span>
              )}
          </div>
        </EahsForm>
      )}

      {/* How to receive a horse passport */}
      <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate(
        "web.receiveHorsePassport",
        "How to receive a horse passport"
      )}>
        <div className={eformCheckBox}>
          <NetaqInput
            name={"receiveType"}
            key={"Registration"}
            type={"radioServiceRequest"}
            value={"Registration"}
            label={translate(
              "web.registrationOffice",
              "Received From EAHS Office"
            )}
            onChange={(e) => handleFormChange(e, "receiveType")}
            checked={formModel.isRegistration}
            disabled={handelDisabledButton()}
          />
        </div>
        <div className={eformCheckBox}>
          <NetaqInput
            name={"receiveType"}
            key={"Post"}
            type={"radioServiceRequest"}
            value={"Post"}
            label={translate("web.postOffice", "Post Delivery")}
            onChange={(e) => handleFormChange(e, "receiveType")}
            checked={!formModel.isRegistration}
            disabled={handelDisabledButton()}
          />
        </div>
        <div className={eformCheckBox}>
        </div>

        {!formModel.isRegistration &&
          <>
            <div className={eformInput}>
              <NetaqInput
                label={translate("web.address", "Address")}
                name={"address"}
                type={"text"}
                placeholder={translate("web.enterFullAddress", "Enter Full Address")}
                onChange={handleFormChange}
                value={formModel.address}
                required={true}
                disabled={handelDisabledButton()}
                ref={addressRef}
              />
              {errorAddress && (
                <span style={{ color: "red" }}>
                  {translate("web.requiredField", "Required Field")}
                </span>
              )}
            </div>
            <div className={eformInput}>
              <NetaqInput
                type={'phone'}
                value={formModel.mobile}
                label={translate("web.smsPhoneNo", "Mobile No")}
                name={'mobile'}
                placeholder={'971xxxxxxxxx'}
                required={true}
                onChange={setPhoneNumber}
                setIsPhoneNumberValid={setIsPhoneNumberValid}
                disabled={handelDisabledButton()}
                ref={mobileRef}
              />
              {!isPhoneNumberValid &&
                <div className='text-danger'>
                  {translate('web.phoneNumberIsNotValid', 'Phone Number Is Not Valid')}
                </div>
              }

              {errorMobile && (
                <span style={{ color: "red" }}>
                  {translate("web.requiredField", "Required Field")}
                </span>
              )}
            </div>
          </>
        }
      </EahsForm>

      {/* Comments */}
      {(!!formModel.comment || !!formModel.ownerComment) && (
        <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate("web.comments", "Comments")}>
          {!!formModel.comment && (
            // eahs Comment
            <div className={eformInput}>
              <NetaqInput
                label={translate("web.eahsComments", "EAHS Comments")}
                name={"adminComment"}
                type={"textarea"}
                maxchars={1150}
                value={formModel.comment}
                disabled={true}
              />
            </div>
          )}

          {(!!formModel.ownerComment || formModel.eventName === "SentBack") && (
            // owner Comment 
            <div className={eformInput}>
              <NetaqInput
                label={translate("web.ownerComment", "Owner Comment")}
                name={"ownerComment"}
                type={"textarea"}
                maxchars={1150}
                value={formModel.ownerComment}
                onChange={handleFormChange}
                disabled={formModel.eventName !== "SentBack" ? true : false}
              />
            </div>
          )}
        </EahsForm>
      )}

      <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate("web.terms", "Terms")}>
        {getServiceDefinitionByIdData?.termsList?.map((item, index) => {
          return (
            <div className={eformTerms} key={index}>
              <NetaqInput
                type={"checkbox"}
                label={item}
                name={`option${index + 1}`}
                checked={checkedItems[`option${index + 1}`] || action != null}
                onChange={handleCheckboxChange}
                disabled={formModel.eventName !== ""}
              />
            </div>
          );
        })}
      </EahsForm>

      {/* <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate("web.terms", "Terms")}>
        <div className={eformTerms}>
          <NetaqInput
            type={"checkbox"}
            label={translate(
              "web.ownershipTransferNote2",
              "This application is not valid without original passport"
            )}
            name="option1"
            checked={checkedItems.option1}
            onChange={handleCheckboxChange}
            disabled={formModel.eventName === "" ? false : true}
          />
        </div>
        <div className={eformTerms}>
          <NetaqInput
            type={"checkbox"}
            label={translate(
              "web.ServiceGeneralNote",
              "Service General Note"
            )}
            name="option2"
            checked={checkedItems.option2}
            onChange={handleCheckboxChange}
            disabled={formModel.eventName === "" ? false : true}
          />
        </div>
      </EahsForm> */}

      {/* buttons*/}
      <div className={eFormButtonsContainer}>
        {/* draft/pay/submit btn */}
        {(
          (action == null || action === "edit")
          ||
          (
            action === "approve"
            &&
            (
              formModel.eventName === "SentBack"
              ||
              (formModel.paymentStatus === "Pendding" && formModel.requestsType === "BackOffice")
            )
          )
        ) && (
            <>
              {(formModel.eventName === "" || formModel.eventName === "Draft") &&
                <DraftBtn
                  key={translate("web.draft", "Draft")}
                  onClick={() => handelFormSubmit("Draft", "", "Draft")}
                  disabled={
                    formModel.eventName === "" ||
                      formModel.eventName === "Draft"
                      ? false
                      : true
                  }
                />
              }

              {userProfile?.participateWithoutPayment === true && formModel.eventName !== "SentBack" && action !== "view" && getServiceDefinitionByIdData.serviceFees > 0 && (
                <ApproveAndPayLaterBtn
                  selectedAccountId={profile?.value}
                  isApprove={false}
                  key={`<i class="fa-solid fa-wallet fa-lg marginrightleft-10"></i>                   
                          ${translate("web.payLater", "Pay Later")}
                          `}
                  onClick={() =>
                    handelFormSubmit("Draft", "no", "Pay")
                  }
                  disabled={
                    formModel.eventName === "SentBack"
                      ? true
                      : false
                  }
                />
              )}

              {formModel.eventName !== "SentBack" && action !== "view" && getServiceDefinitionByIdData.serviceFees > 0 && (
                <SubmitAndPay
                  selectedAccountId={profile?.value}
                  key={translate("web.approvePay", "Approve And Pay")}
                  onClick={() =>
                    handelFormSubmit("Draft", "yes", "Pay")
                  }
                  disabled={
                    formModel.eventName === "SentBack"
                      ? true
                      : false
                  }
                />
              )}

              {(getServiceDefinitionByIdData.serviceFees === 0 || (formModel.eventName === "SentBack" && action !== "view")) && (
                <SubmitServiceBtn
                  key={translate("web.submit", "Submit")}
                  onClick={() =>
                    handelFormSubmit("Submit", "", "Submit")
                  }
                  disabled={
                    getServiceDefinitionByIdData.serviceFees === 0 || formModel.eventName === "SentBack"
                      ? false
                      : true
                  }
                />
              )}
            </>
          )}
      </div>
    </>
  );
}
